// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1BWAz","modalForm":"UpgradeEpcsModal_modalForm__avOjq","modalFooter":"UpgradeEpcsModal_modalFooter__UjTjN"};